import type { App } from 'vue'
import type { Router } from 'vue-router'

function loadScriptBody(trackerScript: string, async = true, elementId: string | null = null): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = trackerScript
    script.async = async
    if (elementId) script.id = elementId
    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode!.insertBefore(script, firstScript)
    script.onload = () => resolve()
    script.onerror = reject
  })
}

export function objectExist(name: string): Promise<void> {
  return new Promise((resolve) => {
    const checkInterval = 50
    const timeout = 3000
    const waitStart = Date.now()
    const interval = setInterval(() => {
      if ((window as any)[name]) {
        clearInterval(interval)
        return resolve()
      }
      if (Date.now() >= waitStart + timeout) {
        clearInterval(interval)
        throw new Error(`window.${name} undefined after waiting for ${timeout}ms`)
      }
    }, checkInterval)
  })
}

export function getMauticContactId(): string | null {
  try {
    return localStorage.getItem('mtc_id')
  } catch {
    return null
  }
}

export default {
  install(app: App, setupOptions: { trackerScript?: string; router?: Router } = {}) {
    const trackerScript = setupOptions.trackerScript || 'https://clients.infodiagram.com/mtc.js'
    const router = setupOptions.router
    ;(window as any).MauticTrackingObject = 'mt'
    ;(window as any).mt = (window as any).mt || function () { ((window as any).mt.q = (window as any).mt.q || []).push(arguments) }
    loadScriptBody(trackerScript)
      .then(() => objectExist('MauticJS'))
      .then(() => {
        (window as any).mt('send', 'pageview')
        app.config.globalProperties.$mautic = (window as any).mt
        if (router) {
          router.afterEach(() => {
            setTimeout(() => {
              (window as any).mt('send', 'pageview')
            }, 1000)
          })
        }
      })
  }
}
